import { createLazyFileRoute } from "@tanstack/react-router";

import { EditTestResultSpecPage } from "@/features/admin/routes/TestSpecsResultSpec";

export const Route = createLazyFileRoute(
  "/_auth/admin/tests/$id/edit/results/$specId",
)({
  component: () => {
    const params = Route.useParams();
    return <EditTestResultSpecPage {...params} />;
  },
});
